export default {
  state: {
    dept: [],  // 机构数据
  },
  getters: {
    dept: state => state.dept
  },
  mutations: {
    setDept(state, dept){  // 设置机构数据
      state.dept = dept;
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dept.js